import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Copy, Monitor, X, Heart } from "lucide-react";
import { toast } from "sonner";

const waPhone = (p) => {
  const c = (p || "").replace(/\D/g, "");
  return c.startsWith("0") ? "62" + c.slice(1) : c;
};

// Popup setelah order disimpan Selesai + Lunas (Tunai/Transfer/QRIS): pesan terima kasih + link ulasan Google
// dari Shortcut Pesan WA sesuai wilayah/jenis pekerjaan; admin salin & kirim manual ke pelanggan.
const ThanksModal = ({ orderId, onClose }) => {
  const [info, setInfo] = useState(null);
  const [pick, setPick] = useState("");
  const [text, setText] = useState("");

  useEffect(() => {
    api.get(`/orders/${orderId}/thanks-message`).then(({ data }) => {
      setInfo(data);
      const opt = data.options.find((o) => o.key === data.area);
      setPick(data.area || "");
      setText(opt?.message || "");
    }).catch((e) => { toast.error(e?.response?.data?.detail || "Gagal memuat pesan terima kasih"); onClose(); });
    // eslint-disable-next-line
  }, [orderId]);

  const choose = (key) => {
    setPick(key);
    setText(info.options.find((o) => o.key === key)?.message || "");
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); toast.success("Pesan disalin"); } catch (_) { toast.error("Gagal menyalin — salin manual dari kotak pesan"); }
  };
  const openDesktop = async () => {
    try { await navigator.clipboard.writeText(text); } catch (_) { /* noop */ }
    window.location.href = `whatsapp://send?phone=${waPhone(info?.phone)}&text=${encodeURIComponent(text)}`;
    toast.success("Pesan disalin & WhatsApp Desktop dibuka");
  };

  const opt = info?.options.find((o) => o.key === pick);
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-[60]" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="bg-white border border-[#E4E4E7] w-full max-w-lg max-h-[92vh] overflow-y-auto" data-testid="thanks-modal">
        <div className="px-5 py-4 border-b border-[#E4E4E7] flex items-start justify-between gap-2">
          <div className="min-w-0">
            <div className="label-cap text-[10px] flex items-center gap-1 text-[#059669]"><Heart size={11} /> Order Selesai & Lunas</div>
            <h2 className="font-heading text-lg font-bold truncate">Kirim Ucapan Terima Kasih</h2>
            {info && <div className="text-xs text-[#52525B] truncate">{info.order_no} · {info.customer_name} · <span className="font-mono">{info.phone || "tanpa no HP"}</span></div>}
          </div>
          <button onClick={onClose} className="p-1.5 hover:bg-[#F4F4F5]" data-testid="thanks-close"><X size={16} /></button>
        </div>
        {!info ? <div className="p-6 text-sm text-[#52525B]">Memuat…</div> : (
          <div className="p-5 space-y-3">
            <div>
              <label className="label-cap block mb-1 text-[10px]">Template (Shortcut Pesan)</label>
              <select value={pick} onChange={(e) => choose(e.target.value)} data-testid="thanks-template" className="w-full px-3 py-2 border border-[#E4E4E7] text-sm bg-white outline-none focus:border-[#002FA7]">
                {!info.area && <option value="">— Wilayah tidak dikenali, pilih template —</option>}
                {info.options.map((o) => <option key={o.key} value={o.key}>{o.label} · /{o.shortcut}{o.missing ? " (belum ada)" : ""}</option>)}
              </select>
              {!info.area && <p className="text-[10px] text-[#D97706] mt-1">Wilayah/jenis pekerjaan order tidak cocok otomatis — pilih template yang sesuai.</p>}
              {opt?.missing && <p className="text-[10px] text-[#DC2626] mt-1">Shortcut /{opt.shortcut} belum ada di menu WhatsApp → Shortcut Pesan.</p>}
            </div>
            <textarea rows={8} value={text} onChange={(e) => setText(e.target.value)} data-testid="thanks-text" className="w-full px-3 py-2 border border-[#E4E4E7] text-sm outline-none focus:border-[#002FA7] font-mono" />
            <div className="flex gap-2 flex-wrap justify-end">
              <button onClick={onClose} className="px-4 py-2 text-xs font-bold uppercase border border-[#E4E4E7]">Nanti</button>
              <button onClick={copy} disabled={!text} data-testid="thanks-copy" className="px-4 py-2 text-xs font-bold uppercase border border-[#002FA7] text-[#002FA7] flex items-center gap-1.5 disabled:opacity-50"><Copy size={13} /> Salin</button>
              <button onClick={openDesktop} disabled={!text || !info.phone} data-testid="thanks-wa" className="px-4 py-2 text-xs font-bold uppercase bg-[#059669] text-white flex items-center gap-1.5 disabled:opacity-50"><Monitor size={13} /> Salin & Buka WA</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ThanksModal;
